"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ClientStage;
(function (ClientStage) {
    ClientStage["SANDBOX"] = "SANDBOX";
    ClientStage["DEVO"] = "DEVO";
    ClientStage["PROD"] = "PROD";
})(ClientStage || (ClientStage = {}));
exports.default = ClientStage;
